import url from "postcss-url"

// [P194] ★ 环境自适应：不再硬编码环境域名。
//   index.html 以 <script> 方式先行加载 static/config.js（非打包模块），
//   其中 window.config.serverIP 已按「当前部署环境」推导出正确的 API 地址
//   （cs10 => liubaics10.api...，cs7/cs8 => 各自域名）。
//   这样同一份构建产物可同时部署到 cs7 / cs8 / cs10，不会把上传/下载指向对端环境。
//   兜底：若 config.js 未加载（极少见），回退为「当前页面同源」，绝不写死某个环境。
//   【P395】cs8 已升级为生产环境，cs10 独立 ⇒ static/config.js 的 url 已改回 cs10。
function _runtimeApiBase() {
    try {
        if (typeof window !== "undefined" && window.config && window.config.serverIP) {
            return String(window.config.serverIP)
        }
    } catch (e) { /* ignore */ }
    if (typeof window !== "undefined" && window.location && window.location.origin) {
        return window.location.origin + "/"
    }
    return ""
}

const config = {
    logo: '../src/assets/images/logo.png',
    userInfo:{},
    get downloadUrl() { return _runtimeApiBase() },
}

export {config}



// WEBPACK FOOTER //
// ./src/util/config.js